import { useState } from "react";
import { DenovoIcon, Pressable, Typography } from "@repo/design-system";
import { Link, Outlet, useLocation } from "react-router-dom";

const navItems = [
  { label: "Home", path: "/" },
  { label: "Molecular Data", path: "/data" },
  { label: "Visual Analysis", path: "/visual-analysis" },
  { label: "Contact Us", path: "/contact" },
];

export function AppLayout() {
  const location = useLocation();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const isActive = (path: string) => {
    if (path === "/") {
      return location.pathname === "/" || location.pathname === "/home";
    }
    return location.pathname.startsWith(path);
  };

  return (
    <div className="flex min-h-screen flex-col bg-backgroundPrimary">
      <header className="sticky top-0 z-50 w-full bg-n900 shadow-medium">
        <div className="flex h-24 w-full items-center justify-between px-6 md:px-12">
          <Link to="/" className="flex items-center gap-4">
            <span className="block md:hidden">
              <DenovoIcon
                icon="app-logo-mobile"
                width={48}
                height={48}
                className="text-backgroundBrand"
              />
            </span>
            <Typography variant="heading-4" className="text-white md:hidden">
              BSA-DB
            </Typography>
            <span className="hidden md:block">
              <img
                src="/denovo-dark.png"
                alt="Denovo Sciences"
                className="h-12 w-auto object-contain"
              />
            </span>
            <Typography
              variant="heading-4"
              className="hidden text-white md:block">
              BSA-DB: Broad Spectrum Antivirals Database
            </Typography>
          </Link>

          {/* Desktop navigation — right side, loose spacing */}
          <nav className="hidden items-center gap-16 md:flex">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className="group flex flex-col items-center gap-0.5">
                <Typography
                  variant="paragraph-xl-medium"
                  className="text-white transition-opacity group-hover:opacity-80">
                  {item.label}
                </Typography>
                <span
                  className={`h-0.5 w-full rounded-full transition-all ${
                    isActive(item.path) ? "bg-white" : "bg-transparent"
                  }`}
                />
              </Link>
            ))}
          </nav>

          <Pressable
            className="cursor-pointer p-2 md:hidden"
            onPress={() => setMobileMenuOpen((o) => !o)}>
            <DenovoIcon
              icon={mobileMenuOpen ? "close" : "menu"}
              width={28}
              height={28}
              className="text-white"
            />
          </Pressable>
        </div>

        {mobileMenuOpen && (
          <nav className="border-t border-white/10 bg-n900 px-6 pb-4 md:hidden">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                onClick={() => setMobileMenuOpen(false)}
                className="flex flex-col gap-0.5 py-3">
                <Typography
                  variant="paragraph-xl-medium"
                  className="text-white transition-opacity hover:opacity-80">
                  {item.label}
                </Typography>
                <span
                  className={`h-0.5 w-8 rounded-full transition-all ${
                    isActive(item.path) ? "bg-white" : "bg-transparent"
                  }`}
                />
              </Link>
            ))}
          </nav>
        )}
      </header>

      <main className="flex-1">
        <Outlet />
      </main>
    </div>
  );
}
